module.exports = __webpack_public_path__ + "static/media/avi.2c49d78e.svg";